import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Row, Spinner, Card } from 'react-bootstrap';
import { FaPlus, FaShoppingCart } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';
import ModalProductos from '../ModalProductos';
import ProductoCard from './ProductoCard';
import { useToast } from 'context/providers/ToastProvider';

const ProductosContainer = (
    {
        productosAgregados = [],
        setProductosAgregados,
        ordenDetallesProductos = []
    }


) => {

    const { token, setToken } = useToken();
    const ejecutadoRef = useRef(false);
    const [cargando, setCargando] = useState(false);
    const [mostrarModal, setMostrarModal] = useState(false);
    const { showErrorToast } = useToast();

    useEffect(() => {
        if (!ejecutadoRef.current && ordenDetallesProductos && Array.isArray(ordenDetallesProductos) && ordenDetallesProductos.length > 0) {
            ordenDetallesProductos.forEach((producto) => {
                agregarProducto(producto);
            });
            ejecutadoRef.current = true; // Marcar como ejecutado
        }
    }, [ordenDetallesProductos]);


    /**
     * Obtiene un producto por su ID
     */
    const ObtenerProductoPorID = async (idProducto, idProductoPrecio) => {
        setCargando(true)

        const response = await fetch("/api/contabilidad/facturas/FormularioFactura/ObtenerProductoPorID", // Cambia el endpoint si es necesario
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(idProducto)
            })
            .catch((error) => {

                showErrorToast('Hubo un problema con la petición Fetch: ' + error);
                console.log('Hubo un problema con la petición Fetch:', error);
            });

        if (response?.ok) {
            setCargando(false);
            console.log("==== OBTENER PRODUCTO ====");
            const data = await response.json();
            console.log("dataRF: ", data);

            if (data.iResponseType === 1) {
                setMostrarModal(false)

                var ObjDetalles = JSON.parse(data.detalles);
                console.log("ObjDetallesPD:", ObjDetalles);

                const list = ObjDetalles.table2 || [];
                const selectedProductPrice = idProductoPrecio
                    ? list.find(p => p.idProductoPrecio === idProductoPrecio) || list[0]
                    : list[0];

                agregarProducto(selectedProductPrice);

            } else {

                showErrorToast(data.vMessage);
            }
        } else {
            setCargando(false);

            showErrorToast(response?.status + ' ' + response?.statusText);
            if (response?.status === 401) {
                setToken(null);
                location.href = "";
            }
        }
    };


    /**
     * Actualiza el campo de un producto específico usando idProducto
     */
    const actualizarCampo = (idUnica, campo, valor) => {
        setProductosAgregados((prevProductos) => {
            return prevProductos.map((producto) => {
                if (producto.idUnica !== idUnica) return producto; // No modificar otros productos

                // Actualizar el campo sin conversión
                const productoActualizado = {
                    ...producto,
                    [campo]: valor,
                };

                // Recalcular Importe, IVA y Total
                const importe = productoActualizado.dCantidad * productoActualizado.dPrecioUnitario;

                let iva = 0;
                if (productoActualizado.vTipoFactorIVA === "Tasa") {
                    // Corrección: Calcular IVA sobre el importe (precio base)
                    iva = importe * productoActualizado.dTasaCuotaIVA;
                } else if (productoActualizado.vTipoFactorIVA === "Cuota") {
                    iva = productoActualizado.dTasaCuotaIVA; // Cuota fija
                } // Si es "Exento", el IVA ya es 0

                const total = importe + iva;

                // Actualizar IVA y Total en el producto
                return { ...productoActualizado, dIVA: iva, dTotal: total, dImporte: importe };
            });
        });
    };

    /**
     * Agrega el producto a la tabla de productos
     */
    const agregarProducto = (producto) => {
        let dIVA = 0.0;
        const dPrecioUnitario = producto.dPrecioUnitario ?? 0.0;
        // Usar la cantidad del producto si existe, sino usar 1 como predeterminada
        const dCantidad = producto.dCantidad ?? 1;

        // Calcular el importe primero (precio unitario * cantidad)
        const dImporte = dPrecioUnitario * dCantidad;

        if (producto.vTipoFactorIVA === "Tasa") {
            // Calcular IVA sobre el importe (precio base * cantidad)
            dIVA = dImporte * (producto.dTasaCuotaIVA ?? 0.0);
        } else if (producto.vTipoFactorIVA === "Cuota") {
            // Si el tipo de factor es "Cuota", simplemente se suma el IVA como un monto fijo
            dIVA = producto.dTasaCuotaIVA ?? 0.0;
        }

        // Calcular el total sumando el IVA al importe
        const dTotal = dImporte + dIVA;

        const idUnica = uuidv4();

        const productoProcesado = {
            idUnica, // ID única para el manejo interno
            idProducto: producto.idProducto,
            idProductoPrecio: producto.idProductoPrecio,
            vCodigoBarras: producto.vCodigoBarras ?? "",
            vNombreProducto: producto.vNombreProducto ?? "Producto sin nombre",
            dPrecioUnitario: dPrecioUnitario,
            dTasaCuotaIVA: producto.dTasaCuotaIVA ?? 0.0,
            vTipoFactorIVA: producto.vTipoFactorIVA ?? "",
            dIVA: dIVA, // IVA calculado correctamente
            dImporte: dImporte, // Mantener ambos por compatibilidad
            vClaveUnidadSat: producto.vClaveUnidadSat ?? "",
            vCodigoProductoServicioSat: producto.vCodigoProductoServicioSat ?? "",
            dTotal: dTotal, // Total con IVA incluido
            dCantidad: dCantidad, // ✅ Usar la cantidad del producto o 1 por defecto
            vImagenProducto_Base64: producto.vImagenProducto_Base64 || null,
            vImagenProducto_Name: producto.vImagenProducto_Name || null,
        };

        const file_jpg = producto.vImagenProducto_Base64
            ? base64ToFile(producto.vImagenProducto_Base64, producto.vImagenProducto_Name)
            : null;

        const imagenURL = file_jpg ? URL.createObjectURL(file_jpg) : null;

        // Agregar el producto a la lista
        setProductosAgregados((prevProductos) => [...prevProductos, { ...productoProcesado, imagenURL }]);
    };




    /**
     * Elimina producto de la tabla de productos agregados y lo regresa a disponibles
     */
    const eliminarProducto = (index) => {

        // Filtrar los productos agregados para eliminar el seleccionado
        const nuevosProductosAgregados = productosAgregados.filter((_, i) => i !== index);
        setProductosAgregados(nuevosProductosAgregados);

    };

    /**
     * Convertir Base64 a archivo
     */
    const base64ToFile = (base64String, fileName) => {
        // Validar si no hay imagen
        if (!base64String) return null;

        try {
            // Extraer el contenido Base64 de manera segura
            const base64Data = base64String?.split(',')[1] || base64String;

            // Validar formato Base64
            if (!/^[A-Za-z0-9+/=]*$/.test(base64Data)) {
                console.error('Formato Base64 inválido');
                return null;
            }

            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const mimeType = base64String.split(';')[0]?.split(':')[1] || 'image/jpeg';

            return new File([new Blob([byteArray], { type: mimeType })], fileName, {
                type: mimeType,
                lastModified: Date.now()
            });

        } catch (error) {
            console.error('Error al convertir Base64 a File:', error);
            return null;
        }
    };



    // Calcular totales
    const calcularTotales = () => {
        const subtotal = productosAgregados.reduce((acc, prod) => acc + prod.dImporte, 0);
        const totalIVA = productosAgregados.reduce((acc, prod) => acc + prod.dIVA, 0);
        const total = productosAgregados.reduce((acc, prod) => acc + prod.dTotal, 0);
        return { subtotal, totalIVA, total };
    };

    const { subtotal, totalIVA, total } = calcularTotales();


    return (
        <>
            {cargando &&
                (
                    <h6>
                        <Spinner className="text-inline" animation="border" variant="primary" /> Cargando...
                    </h6>
                )}
            <Card className="factura-card mb-1 bg-white">
                <Card.Body className="factura-card-body">
                    <Row>
                        <Col md={12}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="seccion-titulo mb-0">Productos de la Factura</h5>
                        <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => setMostrarModal(true)}
                        >
                            <FaPlus className="me-2" size={12} /> Agregar Producto
                        </Button>
                    </div>

                    {/* Contenedor de productos */}
                    <div>
                        {productosAgregados.length === 0 ? (
                            <div
                                className="text-center py-5"
                                style={{
                                    background: 'white',
                                    borderRadius: '8px',
                                    border: '2px dashed #d0d0d0',
                                }}
                            >
                                <FaShoppingCart size={50} color="#d0d0d0" className="mb-3" />
                                <h6 className="text-muted mb-1">No hay productos agregados</h6>
                                <p className="text-muted small mb-0">Haz clic en "Agregar Producto" para comenzar</p>
                            </div>
                        ) : (
                            <>
                                {/* Lista de productos */}
                                <div
                                    style={{
                                        maxHeight: "500px",
                                        overflowY: "auto",
                                        paddingRight: '8px',
                                    }}
                                    className="custom-scrollbar"
                                >
                                    {productosAgregados.map((producto, index) => (
                                        <ProductoCard
                                            key={index}
                                            producto={producto}
                                            index={index}
                                            actualizarCampo={actualizarCampo}
                                            eliminarProducto={eliminarProducto}
                                        />
                                    ))}
                                </div>

                                {/* Resumen de totales profesional */}
                                <div className="mt-3 border border-200 rounded-3 overflow-hidden">
                                    <Row className="g-0 align-items-stretch">
                                        <Col xs={12} md={4}>
                                            <div className="p-3 text-800">
                                                <p className="mb-1 small fw-medium text-500">Subtotal</p>
                                                <h5 className="mb-0 fw-bold">
                                                    ${subtotal.toFixed(2)}
                                                </h5>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <div className="p-3 text-800">
                                                <p className="mb-1 small fw-medium text-500">IVA</p>
                                                <h5 className="mb-0 fw-bold">
                                                    ${totalIVA.toFixed(2)}
                                                </h5>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <div className="bg-primary text-white p-3 h-100 d-flex flex-column justify-content-center">
                                                <p className="mb-1 small text-white-50 fw-medium">
                                                    Total
                                                </p>
                                                <h4 className="mb-0 text-white fw-bold">
                                                    ${total.toFixed(2)}
                                                </h4>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </>
                        )}
                    </div>
                </Col>

                {/* Estilos para el scrollbar */}
                <style jsx>{`
                .custom-scrollbar::-webkit-scrollbar {
                    width: 6px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: #009bdb;
                    border-radius: 4px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: #007a9e;
                }
            `}</style>

                {
                    mostrarModal &&
                    <>
                        <ModalProductos
                            mostrarModal={mostrarModal}
                            setMostrarModal={setMostrarModal}
                            ObtenerProductoPorID={ObtenerProductoPorID}
                            agregarProducto={agregarProducto}
                            productosAgregados={productosAgregados}
                        />
                    </>

                }
                </Row>
            </Card.Body>
        </Card>
        </>
    );
};


ProductosContainer.propTypes = {
    productosAgregados: PropTypes.array,
    ordenDetallesProductos: PropTypes.array,
    setProductosAgregados: PropTypes.func,
    setCargando: PropTypes.func
};

export default ProductosContainer;



